import React from "react";
import RejectButton from "@components/FlowActionButtons/RejectButton";
import { canUserReject } from "./utils";

interface RejectMovementProps {
  movementFlowData?: {
    id: string;
    task: { status: string; claimOwnerName: string } | null;
    status: string;
    terminalReport: { report: string } | null;
    to: string;
    from: string;
  };
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "vessel-call.movement-services";

const RejectMovement: React.FC<RejectMovementProps> = ({ movementFlowData, openDrawer }) => {
  if (!movementFlowData || !movementFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserReject(
    movementFlowData.task.status,
    movementFlowData.task.claimOwnerName,
    movementFlowData.status,
    movementFlowData.to,
  );
  const handleRejectClick = () => {
    openDrawer("rejectDrawer");
  };

  return (
    <RejectButton
      langBase={LANG_BASE}
      permission="canRejectMovementService"
      isActionAvailable={isActionAvailable}
      onReject={handleRejectClick}
    />
  );
};
export default RejectMovement;
